import React, { useState } from 'react';
import './solutions.scss';
import Zoom from 'react-reveal/Zoom';
import Flip from 'react-reveal/Flip';
import Flash from 'react-reveal/Flash';
import { MathComponent } from 'mathjax-react'
import MathJax from 'react-mathjax';
import { CopyBlock, dracula } from "react-code-blocks";
import { problem_4a, problem_4b, TopBar } from "../../snippets";

const Four = (props) => {
    const [language, changeLanguage] = useState("JavaScript");
    const [language_b, changeLanguage_b] = useState("JavaScript");
    const [languageDemo, changeDemo] = useState(problem_4a["JavaScript"]);
    const [languageDemo_b, changeDemo_b] = useState(problem_4b["JavaScript"]);
    const [lineNumbers, toggleLineNumbers] = useState(false);
    const [process, setProcess] = useState(false);
    const [maxPal, setMaxPal] = useState(null);
    const [scaleProcess, setScaleProcess] = useState(false);
    //const [maxNumScale, setMaxNumScale] = useState(4000000);

    //problem implementation logic
    function isPalind(sVal){
        return sVal == sVal.split('').reverse().join('')
    }

    const runProcess = () => {  
        let maximumPal = 0
        for (let i=100; i<=999; i++){
            for (let j=100; j<=999; j++){
                let prod = i*j
                let strProd = prod.toString()
                if ((isPalind(strProd)) && (prod > maximumPal)){
                    maximumPal = prod
                }
           }
        }
        console.log(maximumPal)
        //setMaxPal(maximumPal)
        return maximumPal
    }
        
    const shoot = () =>{
        setProcess(true)
    }

    const reset = () =>{
      setProcess(false)
    }

 /*const runProcessScale = (n) =>{
      let sum = 0, term1 = 0, term2 = 2
      while (term2 < n) {
        sum = sum + term2
        term2 = 4*term2 + term1
        term1 = (term2-term1)/4
      }
      return (sum)
    }


    const shootScale = () =>{
      setScaleProcess(true)
    }
    */

    return(
        <div>
            <p>
                We can loop through (twice) all the 3-digit numbers and multiply each with the other then check each product for palindrome. The highest palindrome would give us the answer to this question.
                <MathComponent tex={String.raw`100 x 100, 100 x 101, 100 x 102,... `} />
                <MathComponent tex={String.raw`..., 999 x 997, 999 x 998, 999 x 999.`} />
            </p>
            <div>
                  <Zoom left>
                    <TopBar
                      language={{
                        value: language,
                        onChange: e => {
                          changeDemo(problem_4a[e.target.value]);
                          return changeLanguage(e.target.value);
                        },
                        options: Object.keys(problem_4a).map(lang => (
                          <option key={lang} value={lang}>
                            {lang}
                          </option>
                        ))
                      }}
                      toggle={{
                        checked: lineNumbers,
                        onChange: e => toggleLineNumbers(!lineNumbers)
                      }}
                    />
                    <CopyBlock
                      language={language}
                      text={languageDemo}
                      showLineNumbers={lineNumbers}
                      theme={dracula}
                      wrapLines={true}
                      codeBlock
                    />   
                </Zoom>
            </div>
            <br />

            <div class="test-form">
                <div class="my-form">
                    <h4 class="brand-title">Let's try it out</h4>
                      <button onClick={shoot}>PROCESS</button>
                </div>
            </div>

              <br />
              {process ? (
                  <p>
                      <Flip>
                        <div class="content-card" align="center">
                          <div class="card-big-shadow">
                              <div class="card card-just-text" data-background="color" data-color="blue" data-radius="none">
                                  <div class="card-content">
                                      <h4 class="description">Result</h4>
                                      <h5 class="title">                      <p>Thelargest palindrome made from the product of two 3-digit numbers is <b id="value">{runProcess()}</b></p></h5>                          
                                  </div>
                              </div>
                          </div>
                        </div>
                      </Flip>
                      <div align="center">
                        <button onClick={reset}>RESET</button>
                      </div> 
                  </p>
              ) : (
                <p> <br /> </p>
              )}
              <br />
        </div>
                   

    )
}
export default Four;